// extracted by mini-css-extract-plugin
export default {"Text":"Description-module__Text--xBFM4","Box":"Description-module__Box--vsN3H"};